// @vendors
import React, { useEffect } from 'react'
import PropTypes from 'prop-types';

// @components
import OKModal from 'components/commons/OKModal/OKModal';
import BrokerConvenienceTestRadioQuestion from "../brokerConvenienceTestRadioQuestion/brokerConvenienceTestRadioQuestion";
const { formatText } = require("core/i18n").i18n;

// @constants
import { PRIVATE_EQUITY_TAGGING_MODAL_DATA } from "mifid/constants/constants";
import { PROC_BROKER_CONVENIENCE_TEST } from "utilities/tagging";

// @utilities
import { taggingEventHandled } from "utilities/taggingEventHandled";

const BrokerConvenienceTestModalQuestion = ({
    isOpen,
    key,
    onChange,
    sectionId,
    answer,
    questionId,
    question,
    disclaimer,
    secondDisclaimer,
}) => {

    useEffect(() => {
        if (isOpen) {
            const taggingData = PRIVATE_EQUITY_TAGGING_MODAL_DATA?.[questionId];
            const previousEventData = window?.utag_data?.accionEvento;
            if (taggingData && taggingData.accionEvento !== previousEventData) {
                const customData = {
                    categoriaEvento: taggingData.categoriaEvento,
                    accionEvento: taggingData.accionEvento,
                };
                taggingEventHandled(
                    PROC_BROKER_CONVENIENCE_TEST,
                    "privateEquityModalShow",
                    customData
                );
            }
        }
    }, [])

    const onContinueClick = () => {
        const taggingData = PRIVATE_EQUITY_TAGGING_MODAL_DATA?.[questionId];
        if (taggingData) {
            let eventTag;
            const answeredQuestion = answer.find((ans) => ans.get("selected") === "S");
            if (answeredQuestion) {
                eventTag = `respuesta-${answeredQuestion.get("description")}`;
            } else {
                eventTag = "Continuar";
            }
            const customData = {
                categoriaEvento: taggingData.categoriaEvento,
                accionEvento: taggingData.accionEvento,
                etiquetaEvento: eventTag,
            };
            taggingEventHandled(
                PROC_BROKER_CONVENIENCE_TEST,
                "privateEquityModalContinue",
                customData
            );
        } 

        onChange(sectionId, questionId, "closeModal");
    }

    const content = (
        <React.Fragment>
            <div>{question}</div>
            <BrokerConvenienceTestRadioQuestion
                key={key}
                onChange={onChange}
                sectionId={sectionId}
                answer={answer}
                questionId={questionId}
                disclaimer={disclaimer}
                secondDisclaimer={secondDisclaimer}
            />
        </React.Fragment>
    );
    const answeredQuestion = answer.some((ans) => ans.get("selected") === "S");
    return (
        <OKModal
            isOpen={isOpen}
            title={formatText(
                "broker-convenienceMifidTestInvestmentExperienceTitleModal"
            )}
            content={content}
            titleAlignment="center"
            footerType="navigation"
            primaryButtonDisabled={!answeredQuestion}
            primaryButtonText="Continuar"
            onPrimaryButtonClick={() =>
               onContinueClick()
            }
        />
    );
};

BrokerConvenienceTestModalQuestion.propTypes = {
    isOpen: PropTypes.bool,
    key: PropTypes.number,
    onChange: PropTypes.func,
    sectionId: PropTypes.string,
    answer: PropTypes.array,
    questionId: PropTypes.string,
    question: PropTypes.string,
    disclaimer: PropTypes.string,
    secondDisclaimer: PropTypes.string
}

export default BrokerConvenienceTestModalQuestion;